export const PAGE_TITLES = {
	'/my_profile/centre': 'Profile centre',
	'/my_profile/change_password': 'Change password',
	'/my_profile/select_categories': {
		authenticated: 'Select categories',
		unAuthenticated: 'Choose your topic experience',
	},
	'/my_profile/select_locations': {
		authenticated: 'Select locations',
		unAuthenticated: 'Where do you come from?',
	},
	'/my_profile/help_centre': 'Terms of service',
	'/my_profile/privacy': 'Privacy Policy',
	'/my_profile/login': {
		authenticated: 'Hello,Login now',
		unAuthenticated: null,
	},
	'/my_profile/register': {
		authenticated: 'Create your new account',
		unAuthenticated: null,
	},
} as const;
